import classNames from 'classnames';
import {
  Accordion as ReactAccordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';

import ArrowDown from '../../images/icon-arrow-down.svg';
import ArrowUp from '../../images/icon-arrow-up.svg';

type Item = {
  id: string | number;
  component: JSX.Element | null;
  hidden?: boolean;
  title: string;
};

type AccordionProps = {
  className?: string;
  items: Item[];
};

export const Accordion = ({ className, items }: AccordionProps) => {
  return (
    <ReactAccordion
      allowMultipleExpanded
      allowZeroExpanded
      className={classNames('accordion', className)}
    >
      {items
        ?.filter((row) => !row.hidden)
        .map((row) => (
          <AccordionItem uuid={row.id} key={row.id}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <h2>{row.title}</h2>
                <AccordionItemState>
                  {({ expanded }) => (expanded ? <ArrowUp /> : <ArrowDown />)}
                </AccordionItemState>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <div className={'content'}>{row.component}</div>
            </AccordionItemPanel>
          </AccordionItem>
        ))}
    </ReactAccordion>
  );
};
